import { ACT_TAG_CHANGE } from "../actions/ActionTypes";

const initialState = {
	tagList:[]
};

export default function(state = initialState, action) {
	if (action.type === ACT_TAG_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}


// WEBPACK FOOTER //
// ./src/reducers/TagReducer.js